/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Injectable} from "@angular/core";
import {FieldsBaseComponent} from "./fields-base/fields-base.component";
import {BtnRadioFieldComponent} from "./fields-types/btn-radio-field/btn-radio-field.component";
import {TextFieldComponent} from "./fields-types/text-field/text-field.component";
import {ColorPickerFieldComponent} from "./fields-types/color-picker-field/color-picker-field.component";
import {DateFieldComponent} from "./fields-types/date-field/date-field.component";
import {TextareaFieldComponent} from "./fields-types/textarea-field/textarea-field.component";
import {CheckboxFieldComponent} from "./fields-types/checkbox-field/checkbox-field.component";
import {SelectFieldComponent} from "./fields-types/select-field/select-field.component";
import {CustomFieldComponent} from "./fields-types/custom-field/custom-field.component";

@Injectable({
  providedIn: 'root'
})
export class FieldsRegistryService {
  registeredComponents:  {[key: string]: typeof FieldsBaseComponent<any>;} = {
    'btn-radio': BtnRadioFieldComponent,
    'checkbox': CheckboxFieldComponent,
    'color-picker': ColorPickerFieldComponent,
    'date': DateFieldComponent,
    'select': SelectFieldComponent,
    'text': TextFieldComponent,
    'textarea': TextareaFieldComponent,
    'custom': CustomFieldComponent
  };

  // Used to register a new type of field in app
  registerFieldType(type: string, component: typeof FieldsBaseComponent<any>) {
    if(this.registeredComponents[type]) return;
    this.registeredComponents[type] = component;
  }

  // Used to retrieve a type of field in app
  getFieldComponent(type: string): typeof FieldsBaseComponent<any> {
    return this.registeredComponents[type];
  }


}
